import { CampaignStatus } from '@retail/campaign/types';
import { useTheme } from '@mui/material';
import { CampaignMessageKey, useCampaignTFunction } from '@retail/campaign/i18n';
import React, { useMemo } from 'react';
import { Chip } from '@shared/components';

interface Props {
  status: CampaignStatus;
  longDescription?: boolean;
}

const longStatusTextMap: Record<CampaignStatus, CampaignMessageKey> = {
  RELEASED: 'campaign.status.released.long',
  UNRELEASED: 'campaign.status.unreleased.long',
  MODIFIED: 'campaign.status.modified.long',
};

const shortStatusTextMap: Record<CampaignStatus, CampaignMessageKey> = {
  RELEASED: 'campaign.status.released.short',
  UNRELEASED: 'campaign.status.unreleased.short',
  MODIFIED: 'campaign.status.modified.short',
};

export const CampaignStatusChip = ({ status, longDescription }: Props) => {
  const t = useCampaignTFunction();
  const theme = useTheme();
  const { status: statusTints } = theme.vars.palette.semantic;

  const statusTint = useMemo(() => {
    switch (status) {
      case 'RELEASED':
        return statusTints.positive;
      case 'UNRELEASED':
      case 'MODIFIED':
        return statusTints.pending;
    }
  }, [statusTints, status]);

  return (
    <Chip
      backgroundColor={statusTint.soft}
      textColor={statusTint.text}
      label={t(longDescription ? longStatusTextMap[status] : shortStatusTextMap[status])}
      size="small"
    />
  );
};
